import styled, { css } from 'styled-components';
import { StickyProps } from './Sticky';
import { visibilityBreakpoint } from '@/styles/utilities';

export const Element = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visibility', 'zIndex', 'bgColor', 'top'].includes(prop),
})<StickyProps>`
  ${({ theme, top, bottom, zIndex, visibility, bgColor }) => {
    return css`
      position: sticky;
      ${top !== undefined &&
      css`
        top: ${top > 0 ? `${top}rem` : top};
      `};

      ${bottom !== undefined &&
      css`
        bottom: ${bottom > 0 ? `${bottom}rem` : bottom};
      `};

      ${bgColor !== undefined &&
      css`
        background: ${theme.color[bgColor]};
      `};

      ${zIndex !== undefined &&
      css`
        z-index: ${zIndex};
      `};

      ${visibilityBreakpoint};
    `;
  }};
`;
